module.exports = __webpack_public_path__ + "static/media/map.73df1beb.png";